/** Matches catalog Availability */
export const Availability = {
  OutOfStock: "OUT_OF_STOCK",
  LowStock: "LOW_STOCK",
  InStock: "IN_STOCK",
  Disabled: "DISABLED",
  Discontinued: "DISCONTINUED",
  Unavailable: "UNAVAILABLE",
  Unknown: "UNKNOWN",
} as const;
export type Availability = (typeof Availability)[keyof typeof Availability];
